var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscover28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 26c6.627 0 12-5.373 12-12S20.627 2 14 2 2 7.373 2 14s5.373 12 12 12Zm-.235-14.756 3.397-1.456c.574-.246.86-.37 1.038-.312a.5.5 0 0 1 .324.324c.057.177-.066.464-.312 1.038l-1.456 3.397c-.28.652-.419.978-.622 1.255a3 3 0 0 1-.644.644c-.277.203-.603.343-1.255.622l-3.397 1.456c-.574.246-.86.37-1.038.312a.5.5 0 0 1-.324-.324c-.057-.177.066-.464.312-1.038l1.456-3.397c.28-.652.419-.978.622-1.255a3 3 0 0 1 .644-.644c.277-.203.603-.343 1.255-.622Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover28);
export default __webpack_public_path__ + "static/media/discover_28.bcd4867f.svg";
export { ForwardRef as ReactComponent };